<template>
  <el-tree ref="tree"
    :data="treeData"
    :highlight-current="true"
    node-key="id"
    empty-text="加载中..."
  >
    <span slot-scope="{ node, data }" class="custom-tree-node">
      <span slot="reference" :style="{ maxWidth: `${128 - data.level * 18}px` }" class="el-tree-node__label">
        {{ node.label }}
      </span>
    </span>
  </el-tree>
</template>

<script lang="ts">
// 个人文件夹选择器
import axios from 'axios'
import {
  getFolder
} from '@/api/resource'
export default {
  name: 'MugedaAiFolderTree',
  props: {
    mediaType: {
      type: String,
      default: 'image'
    }
  },
  data() {
    return {
      treeData: [],
    }
  },
  mounted() {
    // debugger
    // this.getFolders()
  },
  methods: {
    getAllFolders() {
      getFolder({media: this.mediaType,
        version: 4,})
      .then((response) => {
        if (response.status === 0) {
          this.treeData = response.private
          if (this.treeData != null) {
            // 有些混合云会没有private目录

            // 如果没有文件夹，就添加一个默认文件夹
            if (this.treeData.length === 0) {
              const url = '/folder'
              const AddFoldData = new FormData()
              AddFoldData.append('name', '默认文件夹')
              AddFoldData.append('action', 'add')
              AddFoldData.append('media', this.mediaType)
              axios.post(url, AddFoldData).then((res) => {
                if (res.status === 0) {
                  this.getAllFolders()
                }
              })
            }
            //* *************************************
            this.treeData.forEach((ele) => {
              ele.id = ele.ref_id
              ele.label = ele.name
              ele.editing = false
              ele.isNew = false
              ele.children = []
              ele.confirmingDelete = false
              ele.type = 'private'
              if (ele.label === 'default') {
                ele.label = '默认文件夹'
              }
            })

            this.treeData.forEach((ele) => {
              const parentId = ele.parent_id
              let haveParent = false
              this.treeData.forEach((data) => {
                if (data.ref_id === parentId) {
                  haveParent = true
                  return
                }
              })
              if (haveParent === false && parentId !== 0) {
                ele.level = 0
              }
              if (parentId !== 0) {
                this.treeData.forEach((d) => {
                  if (d.id === parentId) {
                    let childArr = d.children
                    ele.level = d.level + 1
                    if (!childArr) {
                      childArr = []
                    }
                    childArr.push(ele)
                    d.children = childArr
                  }
                })
              } else {
                ele.level = 0
              }
            })
            this.treeData = this.treeData.filter(
              (ele) => ele.level === 0 || ele.isexam
            )
          }
        } else {
          this.$message(response.error)
        }
      })
    },
  }
}
</script>
